var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6408 3.98572C21.4007 2.60655 20.5871 1.71941 19.3189 1.47816C18.7939 1.37573 18.2627 1.31004 17.7292 1.28153C15.4724 1.17515 13.2137 1.09157 10.9569 0.996582V1.06877C10.4383 1.06877 9.91876 1.06117 9.39923 1.06877C7.24688 1.10676 5.09269 1.13051 2.95317 1.40881C1.62913 1.57978 0.699105 2.40329 0.427884 3.74826C0.278804 4.52327 0.176288 5.30713 0.120928 6.09531C-0.0183175 7.75219 -0.0348598 9.4177 0.0714481 11.0772C0.142918 12.1163 0.232715 13.1602 0.398562 14.187C0.614806 15.5224 1.4981 16.4048 2.74883 16.5967C3.47962 16.7192 4.21663 16.7978 4.95616 16.8323C7.25971 16.9092 9.56508 16.9814 11.8695 16.9937C14.1447 17.0051 16.4198 16.9491 18.6858 16.7012C19.2713 16.6366 19.8495 16.5397 20.3617 16.1987C21.201 15.6412 21.5904 14.8044 21.6839 13.8184C21.8112 12.4649 21.9377 11.1085 21.9807 9.75123C22.0403 7.82591 21.9734 5.89489 21.6408 3.98572ZM8.81922 12.4478V5.62418L14.535 9.03505L8.81922 12.4478Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.012a64ef875025b11e11b3584d6a701f.svg";
export { ForwardRef as ReactComponent };